module.exports = __webpack_public_path__ + "static/media/icon-live.65b605c1.gif";